import { render } from "./permissions.vue?vue&type=template&id=2c50ed45"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__